import { roundAwayFromZero } from "~/utils/round-away-from-zero";

/**
 * Scale the excl base by the same factor incl was discounted, so VAT and excl
 * stay ≥ 0 even when a discount zeroes the line (PWEB-132). `inclAfter` is the
 * channel's displayed incl (POS `lineTotal`; kiosk floored `unitGrossPrice`).
 * Denominator is rounded so an undiscounted line gives `excl === exclBase`.
 */
export function discountedExclVat(
  exclBase: number,
  inclAfter: number,
  inclBefore: number
): number {
  const beforeRounded = roundAwayFromZero(inclBefore);
  return beforeRounded > 0
    ? (exclBase * Math.max(0, inclAfter)) / beforeRounded
    : exclBase;
}
